export class BitMask<T extends number> {
  constructor(public maskedBinary = 0) {}

  apply(mask: T): void {
    this.maskedBinary |= mask;
  }

  reset(): void {
    this.maskedBinary &= ~this.maskedBinary;
  }

  partialReset(mask: T): void {
    this.maskedBinary &= ~mask;
  }

  /** calls console.log with binary version of the mask */
  log(): void {
    console.log(this.maskedBinary.toString(2).padStart(8, '0'));
  }
}
